import { defineAction } from '~/prix'
import { z } from 'zod'
import communityGardenFetchAction from './communityGardenFetch.action.json' with { type: 'json' }
import { communityGardenObject } from '../communityGardenObject'

const communityGardenFetchDefinition = defineAction({
  ...communityGardenFetchAction,

  input: z.object({ id: communityGardenObject.shape.id, includeDeleted: z.boolean().nullish() }),
  output: communityGardenObject,
})

export default communityGardenFetchDefinition
